module.exports = __webpack_public_path__ + "static/logos/outside-logo--black-15b06b03acc4b4fcf523fe012d706eca.svg";